import { replaceHtmlEntities } from "@/shared/helpers/parse-html-value";
import { I_GENERIC_ITEMS } from "../model/interface/items.interface";

export interface CategorizedFeatures {
  closet: I_GENERIC_ITEMS[];
  condominiumData: I_GENERIC_ITEMS[];
  cabinets: I_GENERIC_ITEMS[];
  frames: I_GENERIC_ITEMS[];
  improvements: I_GENERIC_ITEMS[];
  floors: I_GENERIC_ITEMS[];
  doors: I_GENERIC_ITEMS[];
  roof: I_GENERIC_ITEMS[];
  location: I_GENERIC_ITEMS[];
  usage: I_GENERIC_ITEMS[];
  windows: I_GENERIC_ITEMS[];
  houseType: I_GENERIC_ITEMS[];
  roofForm: I_GENERIC_ITEMS[];
}
export interface CategorizedFeaturesProject {
  project: CategorizedFeatures;
  unit: CategorizedFeatures;
}

function categorizeFeaturesProjectHelper(
  data: Root
): CategorizedFeaturesProject {
  const categorizedFeatures: Record<string, any> = {};
  const categorizedFeaturesProject: Record<string, any> = {};

  data.project.forEach(item => {
    const name = item.name;
    if (typeof item.values == "string") {
      categorizedFeaturesProject[name] = [
        { label: replaceHtmlEntities(item?.values), value: item.values }
      ];
    } else {
      categorizedFeaturesProject[name] = item?.values?.map(
        (value: any) => ({
          label: replaceHtmlEntities(value.name),
          value: value.id,
          id: value.id,
          name: value.name
        })
      );
    }
  });

  data.unit.forEach(item => {
    const name = item.name;
    if (typeof item.values == "string") {
      categorizedFeatures[name] = [
        { label: replaceHtmlEntities(item?.values), value: item.values }
      ];
    } else {
      categorizedFeatures[name] = item?.values?.map((value: any) => ({
        label: replaceHtmlEntities(value.name),
        value: value.id,
        id: value.id,
        name: value.name
      }));
    }
  });

  return {
    project: {
      closet: categorizedFeaturesProject?.Closets ?? [],
      condominiumData:
        categorizedFeaturesProject["Datos Condominio"] ?? [],
      cabinets: categorizedFeaturesProject?.Gabinetes ?? [],
      frames: categorizedFeaturesProject?.Marcos ?? [],
      improvements: categorizedFeaturesProject?.Mejoras ?? [],
      floors: categorizedFeaturesProject?.Pisos ?? [],
      doors: categorizedFeaturesProject?.Puertas ?? [],
      roof: categorizedFeaturesProject?.Techo ?? [],
      location: categorizedFeaturesProject["Ubicaci&oacute;n"] ?? [],
      usage: categorizedFeaturesProject?.Uso ?? [],
      windows: categorizedFeaturesProject?.Ventanas ?? [],
      houseType: categorizedFeaturesProject?.Casa ?? [],
      roofForm: categorizedFeaturesProject["Forma techo"] ?? []
    },
    unit: {
      closet: categorizedFeatures?.Closets ?? [],
      condominiumData: categorizedFeatures["Datos Condominio"] ?? [],
      cabinets: categorizedFeatures?.Gabinetes ?? [],
      frames: categorizedFeatures?.Marcos ?? [],
      improvements: categorizedFeatures?.Mejoras ?? [],
      floors: categorizedFeatures?.Pisos ?? [],
      doors: categorizedFeatures?.Puertas ?? [],
      roof: categorizedFeatures?.Techo ?? [],
      location: categorizedFeatures["Ubicaci&oacute;n"] ?? [],
      usage: categorizedFeatures?.Uso ?? [],
      windows: categorizedFeatures?.Ventanas ?? [],
      houseType: categorizedFeatures?.Casa ?? [],
      roofForm: categorizedFeatures["Forma techo"] ?? []
    }
  };
}

export default categorizeFeaturesProjectHelper;

export interface Root {
  project: Project[];
  unit: Unit[];
}

export interface Project {
  id: number;
  name: string;
  values: Value[];
}

export interface Value {
  id: number;
  name: string;
  feature_id: number;
}

export interface Unit {
  id: number;
  name: string;
  values: Value2[];
}

export interface Value2 {
  id: number;
  name: string;
  feature_id: number;
}
